import { render, staticRenderFns } from "./veStuChangeBack.vue?vue&type=template&id=a2bd3e3a&scoped=true"
import script from "./veStuChangeBack.vue?vue&type=script&lang=js"
export * from "./veStuChangeBack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2bd3e3a",
  null
  
)

export default component.exports